import { 
    SingleCultureCustoms,
} from '../components';
import { useLocation, useParams } from 'react-router-dom';
function PageSacredArt() {
    const { slug } = useParams();
    return (
        <div className="w-full">
            <SingleCultureCustoms passedId={slug}  />
        </div>
    );
}
export default PageSacredArt;